"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Border = void 0;
var react_1 = __importDefault(require("react"));
var components_1 = require("../components");
var Customize_1 = require("./Customize");
var Round_1 = require("./Round");
var Width_1 = require("./Width");
var Border = function () { return (react_1.default.createElement(components_1.Doc, { title: "Border" },
    react_1.default.createElement(Round_1.BorderRound, null),
    react_1.default.createElement(Width_1.BorderWidth, null),
    react_1.default.createElement(Customize_1.BorderCustomize, null))); };
exports.Border = Border;
